import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Button } from 'antd'


const DrawableCloseIcon = () => {
  return (
    <div><Button type="danger" style={{backgroundColor:'#6a582b',border:0}} shape="round" icon={<CloseOutlined />}>
          Close
        </Button></div>
  )
}

export default DrawableCloseIcon